export default __webpack_public_path__ + "static/media/Punto_05_Scali_Rosciano_ENG_Def.55172cf3.aac";